<div class="dialog-wrapper">
  <div class="dialog-header">
    <div class="lock-icon-wrapper">
      <mat-icon class="lock-icon">lock</mat-icon>
    </div>
    <span class="dialog-heading">Protected folder</span>
    <mat-icon class="close-icon cursor-pointer" (click)="cancel()">close</mat-icon>
  </div>

  <p class="dialog-subtitle">
    Enter the password to open
    <strong>{{ data.folderName }}</strong>
  </p>

  <form (ngSubmit)="verify()" #form="ngForm">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Password</mat-label>
      <input
        matInput
        [type]="showPassword ? 'text' : 'password'"
        [(ngModel)]="password"
        name="password"
        required
        autofocus
        (ngModelChange)="isWrong = false"
      />
      <mat-icon matSuffix class="cursor-pointer" (click)="showPassword = !showPassword">
        {{ showPassword ? 'visibility_off' : 'visibility' }}
      </mat-icon>
    </mat-form-field>

    <div *ngIf="isWrong" class="error-message">
      <mat-icon class="error-icon">error_outline</mat-icon>
      Incorrect password. Please try again.
    </div>

    <div class="button-wrapper">
      <span class="cancel-link cursor-pointer" (click)="cancel()">Cancel</span>
      <button
        type="submit"
        class="primary-button custom-button unlock-button"
        [disabled]="!password || isVerifying"
        [class.disabled-button]="!password || isVerifying"
      >
        <mat-icon *ngIf="!isVerifying">lock_open</mat-icon>
        <mat-icon *ngIf="isVerifying" class="spinning">sync</mat-icon>
        {{ isVerifying ? 'Verifying...' : 'Unlock' }}
      </button>
    </div>
  </form>
</div>
